module.exports = __webpack_public_path__ + "img/images.4805c950.png";